import { Section } from 'interfaces/SectionTypes';

import ConfigurationUpdateSection from './ConfigurationUpdateSection';
import ContactSection from './ContactSection';
import HTMLSection from './HTMLSection';
import ImageSection from './ImageSection';
import MarkdownSection from './MarkdownSection';
import SoftwareDownloadSection from './SoftwareDownloadSection';

interface ArticleSectionsProps {
  sections: Section[];
}

const ArticleSections = ({ sections }: ArticleSectionsProps) => {
  return (
    <>
      {sections.map((section: Section, i) => {
        switch (section.type) {
          case 'html':
            return <HTMLSection key={`article_section_${i}`} {...section} />;
          case 'markdown':
            return <MarkdownSection key={`article_section_${i}`} {...section} />;
          case 'Image':
            return <ImageSection key={`article_section_${i}`} {...section} />;
          case 'ContactUs':
            return <ContactSection key={`article_section_${i}`} />;
          case 'SoftwareDownload':
            return <SoftwareDownloadSection key={`article_section_${i}`} {...section} />;
          case 'ConfigurationDownload':
            return <ConfigurationUpdateSection key={`article_section_${i}`} />;
          default:
            return (
              <div
                key={`article_section_${i}`}
                style={{
                  padding: '2rem 0',
                  fontFamily: 'monospace',
                }}
              >
                [{section.type} Component Here]
              </div>
            );
        }
      })}
    </>
  );
};

export default ArticleSections;
